import Select from 'react-select'
import { DELIVERY_LOCATIONS, DELIVERY_NPCS } from '../../data/delivery';
import { useState } from 'react';

const OPTIONS = DELIVERY_LOCATIONS.map(({ label, slug }) => {
	const options = DELIVERY_NPCS
		.filter((npc) => npc.location === slug)
		.map((npc) => ({
			label: `${slug.toUpperCase()}: ${npc.label}`,
			value: `${npc.map} ${npc.coords}`,
		}));

	return { label: label, options };
});

const DeliverySelect = ({ value, onChange }) => {
	const [copyLabel, setCopyLabel] = useState('Copy');
	return (
		<div className={`delivery ${value?.value ? 'has-value' : ''}`}>
			<div className={'delivers-select-wrapper'}>
				<p><strong>Deliver to:</strong></p>
				<Select
					classNamePrefix={'aqh'}
					placeholder={'-- Deliver to --'}
					options={OPTIONS}
					value={value}
					onChange={onChange}
				/>
			</div>
			{value?.value && (
				<div className="clipboard-field">
					<input type="text" readOnly value={`@navi ${value.value}`} />
					<button
						className={copyLabel.toLocaleLowerCase().replace('!', '')}
						onClick={() => {
							navigator.clipboard.writeText(`@navi ${value.value}`);
							setCopyLabel('Copied!');
							setTimeout(() => {
								setCopyLabel('Copy');
							}, 1500);
						}}
					>
						{copyLabel}
					</button>
				</div>
			)}
		</div>
	);
}

export default DeliverySelect;
